import { render } from 'react-dom';
import { StrictMode } from 'react'
import { ToastContainer } from 'react-toastify';
import { PostHogProvider } from 'posthog-js/react'

import App from './App';
import AuthProvider from './auth/AuthProvider';

import './index.css';

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  defaults: '2025-11-30',
} as const

const root = document.createElement('div');
document.querySelector('body')?.appendChild(root);

render(
  <StrictMode>
    <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY as string} options={options}>
      <AuthProvider>
        <App />
        <ToastContainer />
      </AuthProvider>
    </PostHogProvider>
  </StrictMode>,
  root,
);
